/**
 * NotFoundPage
 *
 * Real 404 view for routes that don't exist. Sets a robots:noindex meta
 * so search engines don't index ad-hoc URL fragments and gives the
 * visitor a clear way back into the navigated content.
 */

import { Link, useLocation } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Seo } from '@/components/Seo'
import { useLanguage, useT, STRINGS } from '@/context/LanguageContext'
import './NotFoundPage.css'

const NF_STRINGS = {
  title: { de: 'Seite nicht gefunden', en: 'Page not found' },
  description: {
    de: 'Diese Seite existiert nicht oder wurde verschoben.',
    en: 'This page does not exist or has been moved.',
  },
  body: { de: 'Diese Seite existiert nicht', en: 'This page does not exist' },
  notFoundDetail: { de: ' wurde nicht gefunden.', en: ' could not be found.' },
  hint: {
    de: 'Vielleicht hilft Ihnen eine dieser Routen weiter:',
    en: 'Maybe one of these routes is what you were looking for:',
  },
}

export function NotFoundPage() {
  const location = useLocation()
  const t = useT()
  const { lang } = useLanguage()

  return (
    <main className="not-found-page">
      <Seo
        title={NF_STRINGS.title[lang]}
        description={NF_STRINGS.description[lang]}
      />
      <Helmet>
        <meta name="robots" content="noindex,follow" />
      </Helmet>

      <div className="not-found-container">
        <p className="not-found-code">404</p>
        <h1 className="not-found-title">{NF_STRINGS.body[lang]}</h1>
        <p className="not-found-path">
          <code>{location.pathname}</code>{NF_STRINGS.notFoundDetail[lang]}
        </p>

        <p className="not-found-hint">{NF_STRINGS.hint[lang]}</p>

        <nav className="not-found-links">
          <Link to="/" className="not-found-link">{t(STRINGS.nav.home)}</Link>
          <Link to="/galerie" className="not-found-link">{t(STRINGS.nav.werke)}</Link>
          <Link to="/kuenstlerin" className="not-found-link">{t(STRINGS.nav.kuenstlerin)}</Link>
          <Link to="/ausstellungen" className="not-found-link">{t(STRINGS.nav.ausstellungen)}</Link>
        </nav>
      </div>
    </main>
  )
}
